import { StorageError } from '../errors.js';
/**
 * Run an async op against every provider in parallel.
 * Failures are captured per-provider; never thrown to the caller.
 */
export async function fanOut(providers, op, run, onProviderError) {
    const settled = await Promise.allSettled(providers.map((p) => run(p)));
    return settled.map((result, i) => {
        const providerId = providers[i].id;
        if (result.status === 'fulfilled') {
            return { ok: true, providerId };
        }
        const err = wrapError(providerId, op, result.reason);
        onProviderError?.(providerId, op, result.reason);
        return { ok: false, providerId, error: err };
    });
}
function wrapError(providerId, op, cause) {
    if (cause instanceof StorageError)
        return cause;
    const msg = cause instanceof Error ? cause.message : String(cause);
    return new StorageError(`fan-out ${op} failed: ${msg}`, providerId, op, cause);
}
//# sourceMappingURL=fan-out.js.map